var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "md-column" } },
    [
      _c("md-progress", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadingComponent,
            expression: "loadingComponent"
          }
        ],
        staticClass: "md-accent",
        attrs: { "md-indeterminate": "" }
      }),
      _c(
        "md-theme",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingComponent,
              expression: "!loadingComponent"
            }
          ],
          attrs: { "md-name": "blue" }
        },
        [
          _c("breadcrumbs", {
            attrs: { id: "scrollToError", section: "Series", nav: _vm.nav }
          }),
          _c(
            "md-layout",
            { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
            [
              _c(
                "md-whiteframe",
                {
                  staticClass: "form-wrapper-frame",
                  attrs: { "md-elevation": "3" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "md-headline" },
                    [
                      _vm._v("Images"),
                      _vm.noImagesLive
                        ? _c("p", { staticClass: "errorMessage" }, [
                            _vm._v(
                              'If status is "live" the images are required'
                            )
                          ])
                        : _vm._e(),
                      _c("ImageUploadCroped", {
                        attrs: {
                          accountID: _vm.accountID,
                          "media-item": _vm.serie,
                          "is-series": true
                        },
                        on: {
                          uploadSuccessPoster: _vm.onUploadSuccess,
                          uploadSuccessHero: _vm.onHeroImageUploadSuccess,
                          uploadSuccessPortrait: _vm.onUploadPortraitSuccess
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "md-whiteframe",
                {
                  staticClass: "form-wrapper-frame",
                  attrs: { "md-elevation": "3" }
                },
                [
                  _c("serie-form", {
                    attrs: {
                      entity: _vm.serie,
                      "form-submitted": _vm.formSubmitted,
                      validations: _vm.$v.serie,
                      title: ""
                    }
                  }),
                  _c("status-radio", {
                    model: {
                      value: _vm.serie.status,
                      callback: function($$v) {
                        _vm.$set(_vm.serie, "status", $$v)
                      },
                      expression: "serie.status"
                    }
                  })
                ],
                1
              ),
              _c(
                "md-whiteframe",
                {
                  staticClass: "form-wrapper-frame",
                  attrs: { "md-elevation": "3" }
                },
                [
                  _c("properties-form", {
                    attrs: {
                      entity: _vm.serie,
                      showMarketplaceSwitch: false,
                      "form-submitted": _vm.formSubmitted,
                      validations: _vm.$v.serie
                    }
                  })
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-align": "center" } },
                [
                  _c("stitch-loader", {
                    attrs: { loading: _vm.creatingOrUpdating, size: 40 }
                  }),
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.creatingOrUpdating,
                          expression: "!creatingOrUpdating"
                        }
                      ],
                      staticClass: "md-raised md-primary",
                      attrs: { id: "submit-btn", disabled: _vm.$v.$pending },
                      on: { click: _vm.onFormSubmit }
                    },
                    [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e7c49b9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7c49b9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/serie/SerieForm.vue
// module id = 891
// module chunks = 0